<template>
  <v-container fill-height>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="card" color="primary">
          <v-card-title class="justify-center font-weight-bold">Buscar personal</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="busquedaPersonal.nombre"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Nombre"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.segundoNombre"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Segundo nombre"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.apaterno"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Apellido paterno"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.amaterno"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Apellido materno"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.curp"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="CURP"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.CUIP"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="CUIP"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <v-btn
                    rounded
                    block
                    color="secondary"
                    @click="triggerSearchPersonal()"
                    :disabled="loading || emptyForm"
                    :loading="loading"
                    >Realizar búsqueda</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <v-btn color="secondary" rounded @click="RESET_BUSQUEDA_PERSONAL()">Realizar nueva búsqueda</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <v-text-field
              label="Filtrar elementos"
              v-model="filtroPersonal"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="card" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!personal.foto">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.foto = null"
                  ></v-img>
                </v-col>
                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <div class="text-subtitle-1 font-weight-bold mb-2">Vigencias</div>
            <v-row>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">CUP</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFecha(personal.vigenciaCup) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaCup)"
                      tipoRegla="desarrollo"
                      nombreVigencia="CUP"
                      :fechaVigencia="personal.vigenciaCup"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">Evaluación C3</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFecha(personal.vigenciaEvaluacionC3) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaEvaluacionC3)"
                      tipoRegla="desarrollo"
                      nombreVigencia="Evaluación C3"
                      :fechaVigencia="personal.vigenciaEvaluacionC3"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">Competencias básicas</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFecha(personal.vigenciaCompetenciasBasicas) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaCompetenciasBasicas)"
                      tipoRegla="desarrollo"
                      nombreVigencia="Competencias básicas"
                      :fechaVigencia="personal.vigenciaCompetenciasBasicas"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">Formación inicial</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFecha(personal.vigenciaFormacionInicial) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaFormacionInicial)"
                      tipoRegla="desarrollo"
                      nombreVigencia="Formación inicial"
                      :fechaVigencia="personal.vigenciaFormacionInicial"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="secondary darken-1">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CONDECORAR_ELEMENTO)">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-1"
                        elevation="8"
                        icon="mdi-medal"
                        v-on="on"
                        v-bind="attrs"
                        @click="openCondecoracionPersonalDialog(personal)"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Condecorar a este elemento</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.REALIZAR_EVALUACION_ANUAL)">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-1"
                        elevation="8"
                        :to="{
                          path: 'evaluacion_desempenio_anual/' + personal.idPersonal,
                          params: { idPersonalEvaluado: personal.idPersonal },
                        }"
                        icon="mdi-numeric-1-circle"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Realizar evaluación anual</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.REALIZAR_EVALUACION_DESEMPEÑO)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-1"
                        elevation="8"
                        :to="{
                          path: 'evaluacion_desempenio/' + personal.idPersonal,
                          params: { id: personal.idPersonal },
                        }"
                        icon="mdi-numeric-3-circle"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Realizar evaluación de desempeño</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.SUGERIR_CURSO)">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-1"
                        elevation="8"
                        :to="{ name: 'sugerirCurso', params: { personal: personal } }"
                        icon="mdi-comment-quote"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Sugerir curso</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.ASIGNACION_CUP)">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-1"
                        elevation="8"
                        :to="{ name: 'asignaCup', params: { personal: personal } }"
                        icon="mdi-card-bulleted"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Asignación de CUP</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-1"
                        elevation="8"
                        :to="{
                          name: 'documentosPersonalDesarrollo',
                          params: { id: personal.idPersonal },
                        }"
                        icon="mdi-file-account"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Ver expediente del personal</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <asigna-condecoracion-personal-dialog-component
      :active="condecoracionPersonalDialog"
      :personal="selectedPersonal"
      @close="condecoracionPersonalDialog = false"
    ></asigna-condecoracion-personal-dialog-component>
  </v-container>
</template>
<style scoped>
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import AsignaCondecoracionPersonalDialogComponent from '../../components/desarrollo_policial/condecoraciones/AsignaCondecoracionPersonalDialogComponent.vue'
import IconRoundedButton from '@src/components/base/IconRoundedButton.vue'
import Semaforo from '@/components/SemaforoComponent.vue'
import moment from 'moment'

export default {
  components: {
    AsignaCondecoracionPersonalDialogComponent,
    IconRoundedButton,
    Semaforo,
  },

  data() {
    return {
      loading: false,
      filtroPersonal: '',
      selectedPersonal: null,
      condecoracionPersonalDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    ...mapGetters('tipoAmbito', {
      tipoAmbito: 'getTipoAmbito',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    getMesesRestantes(fechaVigencia) {
      if (!fechaVigencia) return null
      let formato = 'YYYY-MM-DD'
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fechaVigencia)) {
        formato = 'DD/MM/YYYY'
      }
      const fechaMoment = require('moment')(fechaVigencia, formato, true)
      if (!fechaMoment.isValid()) return null
      const meses = fechaMoment.diff(require('moment')(), 'months', true)

      return meses >= 0 ? meses : 0
    },
    formatFecha(fecha) {
      if (!fecha) return 'No registrada'
      if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        return moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        return moment(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY')
      }
      return 'No registrada'
    },

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },

    openCondecoracionPersonalDialog(personal) {
      this.selectedPersonal = personal
      this.condecoracionPersonalDialog = true
      this.loading = false
    },
  },
}
</script>
<style scoped>
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
